export default __webpack_public_path__ + "static/media/milk1.da23a93e.jpg";